const MWLoader = () => (
  <div className='fixed top-0 left-0 w-full h-screen bg-gray-500 bg-opacity-75 flex justify-center items-center' style={{zIndex: 1000}}>
    <div className='w-full h-full flex justify-center opacity-100'>
      <img className='animate-spin w-1/12 lg:w-24 z-60 opacity-100' src='/images/marketwagon-tomato.svg' alt=''/>
    </div>
  </div>
);

export default MWLoader;
